import React from 'react';
import { PortfolioPlSubChartProps } from 'widgets/portfolioPl/chart/PortfolioPlChart';
import './PortfolioPlLeavesChart.scss';
import TimeSeriesChart from 'utils/components/TimeSeriesChart/TimeSeriesChart';
import { computeYDomain, getChartSeries, getHideSeriesClasses } from './series';
import { useYScale } from 'utils/components/TimeSeriesChart/yAxis';
import { postfixNumber } from '@instinet-analytics/core-lib';
import { getBucketedTimeSeries } from 'widgets/portfolioPl/chart/leaves/buckets';
import { useXAxisContext } from 'utils/components/TimeSeriesChart/XAxisContext';
import { PortfolioPlLeavesChartLegends } from 'widgets/portfolioPl/chart/leaves/PortfolioPlLeavesChartLegends';
import { useHorizontalZoomContext } from 'utils/components/Zoom/ZoomContext';

export function PortfolioPlLeavesChart(props: PortfolioPlSubChartProps) {
    const { width, dimensions, config, data, containerLeft } = props;

    const {
        leavesChart: { chartHeight, chartTop },
    } = dimensions;

    const { plotAreaWidth } = useXAxisContext();
    const {
        transform: { k: zoom },
    } = useHorizontalZoomContext();

    const bucketedData = getBucketedTimeSeries(data, plotAreaWidth, zoom);

    const series = getChartSeries(bucketedData, width);
    const yDomain = computeYDomain(config, bucketedData);
    const yScale = useYScale(yDomain, [-1, +1]);
    const hideSeriesClasses = getHideSeriesClasses(config);
    const { leavesCollapsed } = config;

    return (
        <>
            <PortfolioPlLeavesChartLegends
                containerLeft={containerLeft}
                data={data.timeSeries}
                dimensions={dimensions}
            />
            <div
                className={`PortfolioPlLeavesChart ${hideSeriesClasses}`}
                style={{
                    height: chartHeight + 'px',
                    top: chartTop + 'px',
                    width: width + 'px',
                }}
            >
                {!leavesCollapsed && (
                    <TimeSeriesChart
                        id="PortfolioPlLeavesChart"
                        height={chartHeight}
                        data={bucketedData}
                        series={series}
                        displayXAxis={true}
                        yScale={yScale}
                        yTicks={6}
                        yTickFormat={postfixNumber}
                    />
                )}
            </div>
        </>
    );
}
